import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import moment from 'moment'
import { breakpoints } from '@/styles'
import { FieldInput, FieldDropdown } from '../inputs'
import PhoneInput from '../inputs/phone-input'
import { FieldDatePicker } from '../inputs/date-picker'

const AddSigneePrimaryFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    grid-template-columns: 1fr;
  }
`

const AdjustedFieldInput = styled(FieldInput)`
  height: 48px;
`
const AdjustedFieldDropdown = styled(FieldDropdown)`
  height: 48px;
`

const initialMonth = dob => {
  return dob ? moment(dob) : moment().subtract(18, 'years')
}

const BasicInfoInputs = ({ values, editing }) => {
  const { t } = useTranslation()

  return (
    <AddSigneePrimaryFieldsContainer>
      <div>
        <AdjustedFieldInput
          name="first_name"
          placeholder={t('l.contract_edit.first_name.placeholder', 'First Name')}
          required
        />
      </div>
      <div>
        <AdjustedFieldInput
          name="last_name"
          placeholder={t('l.contract_edit.last_name.placeholder', 'Last Name')}
          required
        />
      </div>
      <div>
        <AdjustedFieldInput
          name="email"
          disabled={editing}
          placeholder={t('l.contract_edit.email.placeholder', 'E-mail')}
          required
        />
      </div>
      <div>
        <PhoneInput
          name="phone_number"
          placeholder={t('l.contract_edit.phone_number.placeholder', 'Phone Number')}
          required
        />
      </div>
      <div>
        <FieldDatePicker
          name="dob"
          placeholder={t('l.contract_edit.birthday.placeholder', 'Birthday')}
          initialFocusedDate={initialMonth(values.dob)}
          minDate={moment().subtract(100, 'years')}
          maxDate={moment().subtract(13, 'years')}
          disableFuture
        />
      </div>
      {!editing && (
        <div>
          <AdjustedFieldDropdown
            id="recipient_signing_status"
            name="recipient_signing_status"
            placeholder={t('l.contract_edit.add_recipients.signing_status.title', 'Signing status')}
            options={[
              {
                value: 'signature_required',
                label: t('l.listing.edit.signature_required.text', 'Signature Required')
              },
              {
                value: 'email_notification_required',
                label: t('l.listing.edit.email_notification_required.text', 'Email a copy')
              }
            ]}
          />
        </div>
      )}
    </AddSigneePrimaryFieldsContainer>
  )
}

export default BasicInfoInputs
